'use client';

import posthog from 'posthog-js';

type EventProperties = Record<string, boolean | number | string | undefined>;

function isPostHogConfigured() {
  return Boolean(
    process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN &&
      process.env.NEXT_PUBLIC_POSTHOG_HOST,
  );
}

export function capturePostHogEvent(
  event: string,
  properties?: EventProperties,
) {
  if (isPostHogConfigured()) {
    posthog.capture(event, properties);
  }
}
